import type { IconProps } from "@obs/icons";
import { colors } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";
import type { ReactElement } from "react";

import { type Semantic, semanticColorMap } from "../../../../utils/semantic";

export type AffixProps = {
	disabled?: boolean;
	selected?: boolean;
	icon: {
		Component: (props: IconProps) => ReactElement;
	} & Omit<IconProps, "size" | "iconColor">;
	semantic?: Semantic;
};

const styles = stylex.create({
	root: {
		display: "inline-flex",
		flexDirection: "column",
		justifyContent: "center",
		flexShrink: 0,
	},
});

export const Affix = ({ icon, disabled, selected, semantic = "secondary" }: AffixProps) => {
	const { Component, ...props } = icon;
	const resolvedSemantic = disabled ? "disabled" : semantic;
	const iconColor = selected ? String(colors.neutralTxtInverted) : semanticColorMap[resolvedSemantic];

	return (
		<span {...stylex.props(styles.root)}>
			<Component size={24} iconColor={iconColor} {...props} />
		</span>
	);
};
